export default __webpack_public_path__ + "static/media/napaliCoast.12f22fd4.jpg";